import { Injectable } from '@angular/core';
import * as ZoomAuthentication from "@root/assets/core-sdk/ZoomAuthentication.js/ZoomAuthentication";
import { LivenessCheckProcessor } from '@root/assets/processors/LivenessCheckProcessor';
import { Subject } from 'rxjs';
import { TenantService } from './tenant.service';
import { isNullOrUndefined } from '@shared/utils/utils';
const ZoomSDK = ZoomAuthentication.ZoomSDK;

@Injectable()
export class LivenessDetectionService {

  public DeviceLicenseKeyIdentifier = this.tenantService.getParameter("zoom", "deviceLicenseKeyIdentifier")
  private static isLivenessDetectionSuccess = new Subject<any>();
  public isLivenessDetectionSuccess$ = LivenessDetectionService.isLivenessDetectionSuccess.asObservable();

  private status: any;
  private isLivenessDetectionEnabled: string;

  constructor(private tenantService: TenantService) {
    this.isLivenessDetectionEnabled = this.tenantService.getParameter('upload', 'enableLivenessDetection');

    if (this.isLivenessDetectionEnabled === 'true') {
      //LIVENESS DETECTION
      // Set a the directory path for other ZoOm Resources.
      ZoomSDK.setResourceDirectory("../../assets/core-sdk/ZoomAuthentication.js/resources");

      // Set the directory path for required ZoOm images.
      ZoomSDK.setImagesDirectory("../../assets/core-sdk/zoom_images");

      // Initialize ZoOm and configure the UI features.
      ZoomSDK.initialize(this.DeviceLicenseKeyIdentifier, this.initializeComplete.bind(this));

      this.status = ZoomSDK.getFriendlyDescriptionForZoomSDKStatus(ZoomSDK.getStatus());
    }
  }

  livenessCheck(ZoomLocalizationStrings: any) {

    if (this.isLivenessDetectionEnabled !== 'true') {
      return;
    }
    // Configure the ZoOm Strings
    // @param - ZoomLocalizationStrings: {[key: string]: string}
    // ZoomLocalizationStrings is a JSON defined in ZoomStrings.js sample file
    ZoomSDK.configureLocalization(ZoomLocalizationStrings);
    new LivenessCheckProcessor(this.tenantService, this.onProcessingComplete);
  }

  // Show the final result and transition back into the main interface.
  onProcessingComplete(isSuccess: boolean, zoomSessionResult: ZoomAuthentication.ZoomSessionResult) {
    if (!isNullOrUndefined(zoomSessionResult)){
      this.status = ZoomSDK.getFriendlyDescriptionForZoomSessionStatus(zoomSessionResult.status);
    }
    LivenessDetectionService.isLivenessDetectionSuccess.next(isSuccess);
  }

  // Updates UI when initialization completes
  initializeComplete() {
    if (this.isLivenessDetectionEnabled === 'true') {
      this.status = ZoomSDK.getFriendlyDescriptionForZoomSDKStatus(ZoomSDK.getStatus());
    }
  }

  getStatus() {
    return this.status;
  }
}
